import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { SimpleMessageScreen } from '@/components/system-screens'

function ClearCachePage() {
  const navigate = useNavigate()
  useEffect(() => {
    window.localStorage.clear()
    window.sessionStorage.clear()
    void navigate({ to: '/sign_out', replace: true })
  }, [navigate])
  return <SimpleMessageScreen title="キャッシュをクリアしています">しばらくお待ちください。</SimpleMessageScreen>
}

export const Route = createFileRoute('/clear_cache')({ component: ClearCachePage })
